function join<Base extends string, Path extends string>(
  base: Base,
  path: Path
) {
  return `${base}${path}` as const
}

const ROOTS_CASINO = '/casino' as const
const ROOTS_GAMES = '/games' as const
const ROOTS_SPORTS = '/sports' as const
const ROOTS_CRYPTO = '/crypto' as const
const ROOTS_PROFILE = '/profile' as const
const ROOTS_PROVABLY_FAIR = '/provably-fair' as const

export const PATH_CASINO = {
  lobby: ROOTS_CASINO,
  slots: join(ROOTS_CASINO, '/slots'),
  liveCasino: join(ROOTS_CASINO, '/live-casino'),
  newReleases: join(ROOTS_CASINO, '/new-releases'),
  gameShows: join(ROOTS_CASINO, '/game-shows'),
  originals: join(ROOTS_CASINO, '/originals'),
  tableGames: join(ROOTS_CASINO, '/table-games'),
  roulette: join(ROOTS_CASINO, '/roulette'),
  blackjack: join(ROOTS_CASINO, '/blackjack'),
}

export const PATH_GAMES = {
  plinko: join(ROOTS_GAMES, '/plinko'),
  limbo: join(ROOTS_GAMES, '/limbo'),
  crash: join(ROOTS_GAMES, '/crash'),
  mines: join(ROOTS_GAMES, '/mines'),
  tower: join(ROOTS_GAMES, '/tower'),
  roulette: join(ROOTS_GAMES, '/roulette'),
  hilo: join(ROOTS_GAMES, '/hilo'),
  dice: join(ROOTS_GAMES, '/dice'),
  coinFlip: join(ROOTS_GAMES, '/coin-flip'),
  wheel: join(ROOTS_GAMES, '/wheel'),
  keno: join(ROOTS_GAMES, '/keno'),
  blackjack: join(ROOTS_GAMES, '/blackjack'),
  videoPoker: join(ROOTS_GAMES, '/videoPoker'),
}

export const PATH_SPORTS = {
  root: ROOTS_SPORTS,
  alpineSkiing: join(ROOTS_SPORTS, '/alpine-skiing'),
  americanFootball: join(ROOTS_SPORTS, '/american-football'),
  autoRacing: join(ROOTS_SPORTS, '/auto-racing'),
  badminton: join(ROOTS_SPORTS, '/badminton'),
  bandy: join(ROOTS_SPORTS, '/bandy'),
  baseball: join(ROOTS_SPORTS, '/baseball'),
  basketball: join(ROOTS_SPORTS, '/basketball'),
  boxing: join(ROOTS_SPORTS, '/boxing'),
  chess: join(ROOTS_SPORTS, '/chess'),
  cricket: join(ROOTS_SPORTS, '/cricket'),
  cycling: join(ROOTS_SPORTS, '/cycling'),
  darts: join(ROOTS_SPORTS, '/darts'),
  f1: join(ROOTS_SPORTS, '/formula-1'),
  fieldHockey: join(ROOTS_SPORTS, '/field-hockey'),
  floorball: join(ROOTS_SPORTS, '/floorball'),
  freestyleWrestling: join(ROOTS_SPORTS, '/freestyle-wrestling'),
  futsal: join(ROOTS_SPORTS, '/futsal'),
  gaelicFootball: join(ROOTS_SPORTS, '/gaelic-football'),
  golf: join(ROOTS_SPORTS, '/golf'),
  handball: join(ROOTS_SPORTS, '/handball'),
  hurling: join(ROOTS_SPORTS, '/gaelic-hurling'),
  iceHockey: join(ROOTS_SPORTS, '/ice-hockey'),
  lacrosse: join(ROOTS_SPORTS, '/lacrosse'),
  mma: join(ROOTS_SPORTS, '/mma'),
  motorbikes: join(ROOTS_SPORTS, '/motorbikes'),
  nascar: join(ROOTS_SPORTS, '/nascar'),
  netball: join(ROOTS_SPORTS, '/netball'),
  politics: join(ROOTS_SPORTS, '/politics'),
  rugbyLeague: join(ROOTS_SPORTS, '/rugby-league'),
  rugbyUnion: join(ROOTS_SPORTS, '/rugby-union'),
  snooker: join(ROOTS_SPORTS, '/snooker'),
  soccer: join(ROOTS_SPORTS, '/soccer'),
  speedway: join(ROOTS_SPORTS, '/speedway'),
  squash: join(ROOTS_SPORTS, '/squash'),
  tableTennis: join(ROOTS_SPORTS, '/table-tennis'),
  tennis: join(ROOTS_SPORTS, '/tennis'),
  tvShowsAndMovies: join(ROOTS_SPORTS, '/tv-shows-and-movies'),
  volleyball: join(ROOTS_SPORTS, '/volleyball'),
  waterPolo: join(ROOTS_SPORTS, '/waterpolo'),
}

export const PATH_CRYPTO = {
  root: ROOTS_CRYPTO,
  futures: join(ROOTS_CRYPTO, '/futures'),
}

export const PATH_PROFILE = {
  root: ROOTS_PROFILE,
  transactions: join(ROOTS_PROFILE, '/transactions'),
  rewards: join(ROOTS_PROFILE, '/rewards'),
  settings: join(ROOTS_PROFILE, '/settings'),
}

export const PATH_FAVORITES = '/favorites' as const
export const PATH_AIRDROP = '/airdrop' as const
export const PATH_STAKING = '/staking' as const

export const PATH_PROVABLY_FAIR = {
  root: ROOTS_PROVABLY_FAIR,
  overview: join(ROOTS_PROVABLY_FAIR, '/overview'),
  implementation: join(ROOTS_PROVABLY_FAIR, '/implementation'),
  conversions: join(ROOTS_PROVABLY_FAIR, '/conversions'),
  gameEvents: join(ROOTS_PROVABLY_FAIR, '/game-events'),
  serverSeedUnhash: join(ROOTS_PROVABLY_FAIR, '/server-seed-unhash'),
  calculation: join(ROOTS_PROVABLY_FAIR, '/calculation'),
}
